<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VFIKgg/tc-custom/9781466805842.jpg?1731554438165" alt="This image is the cover for the book Frozen, Detective Ellie MacIntosh"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Frozen, Detective Ellie MacIntosh
      </h1>
      <p class="bookDescription body article font2">
        <b>This thriller featuring a female detective who falls for her lead suspect in a heinous crime “will have you shivering” (Sandra Brown, #1 <i>New York Times</i>–bestselling author of <i>Out of Nowhere</i>).</b><br/><br/>Bryce Grantham wants a quiet vacation at his family’s cabin. On his first night in town, he meets a girl at a bar and gives her a ride home. The next day, he finds her cell phone in his car. When he tries to return it, Bryce discovers that the young woman has vanished, leaving behind only a bloody shoe.<br/><br/>Suddenly Bryce Grantham is the primary suspect in a murder investigation.<br/><br/>Detective Ellie MacIntosch has a serial killer on her hands, but without a body, she has few leads and the stalled investigation has her on edge. Bryce Grantham seems to be the perfect suspect. Especially when Grantham starts stumbling across the bodies of the missing women with unbelievable frequency. The evidence against him is almost irrefutable . . . but Ellie’s gut tells her the case is not so cut and dry.<br/><br/>Before Ellie compromises the investigation, her career, and possibly her life in order to prove Bryce’s innocence, she must determine whether he is a manipulative, cold-blooded killer . . . or the victim of a madman playing a sickening game.<br/><br/>“Watterson draws you in and keeps you riveted until the last page.” —Laura Griffin, <i>New York Times</i>–bestselling author of <i>Twisted</i><br/><br/>“Gripping, atmospheric, and fabulous!” —Carla Neggers, <i>New York Times</i>–bestselling author of <i>Saint’s Gate</i><br/><br/>“A cunning killer who will leave you chilled to the bone.” —CJ Lyons, <i>New York Times</i>–bestselling author of <i>Blind Faith</i><br/><br/>“Kate Watterson is a terrific storyteller.” —Hank Phillippi Ryan, Anthony, Agatha, and Macavity Award–winning author of <i>The House Guest</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kate Watterson
      </h2>
      
      <p class="authorDescription body article"><P><B>Kate Watterson</B> grew up on a steady diet of mystery/suspense novels. If it involves murder and intrigue, she is bound to be hooked. Kate also writes award-winning historical novels as Emma Wildes. She lives in rural Indiana with her husband, three children, and a temperamental cat named Poot.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      A Tom Doherty Associates Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2b2ac3d3